import type { convites as pt } from '../pt-BR/convites';
import type { Traducao } from '../Traducao';

export const convites = {
  status: { nao_enviado: 'No enviada', enviado: 'Aceptada por el servidor', falha: 'Fallo' },
  lembrar: {
    titulo_one: '{{count}} no respondió',
    titulo_other: '{{count}} no respondieron',
    enviar: 'Enviar e-mail',
    pessoas_zero: '{{count}} personas',
    pessoas_one: '{{count}} persona',
    pessoas_other: '{{count}} personas',
    copiarEmails: 'Copiar e-mails',
    bloco: '{{de}}–{{ate}}',
    copiarLink: 'Copiar enlace',
    copiados_one: '{{count}} copiado',
    copiados_other: '{{count}} copiados',
    linkCopiado: 'Enlace copiado',
    semEmail: '{{count}} sin e-mail',
  },
  statusDica: {
    enviado:
      'El servidor de correo aceptó el mensaje; no significa que fue entregado ni leído. No incluye comunicaciones por Teams o WhatsApp.',
  },
  iniciadaIgnorados_one: 'Envío iniciado. {{count}} persona no estaba en la campaña y se omitió.',
  iniciadaIgnorados_other:
    'Envío iniciado. {{count}} personas no estaban en la campaña y se omitieron.',
  previa: {
    titulo: 'Vista previa del correo',
    de: 'De',
    para: 'Para',
    assunto: 'Asunto',
    exemplo: 'Ejemplo con un nombre ficticio',
    semDestinatario: 'Esta persona no recibiría el correo: sin correo o dominio en el registro',
    verPessoa: 'Ver el correo que recibe esta persona',
  },
  rodada: {
    status: { em_andamento: 'En curso' },
    barra: '{{processados}} · {{enviados}}, {{falhas}} con fallo',
    processados_one: '{{feitos}} de {{count}} procesado',
    processados_other: '{{feitos}} de {{count}} procesados',
    enviados_zero: '{{count}} enviadas',
    enviados_one: '{{count}} enviada',
    enviados_other: '{{count}} enviadas',
  },
  ultimoEnvio: {
    titulo: 'Último envío de e-mails',
    concluido_zero: '{{count}} e-mails enviados el {{quando}} por {{nome}}',
    concluido_one: '{{count}} e-mail enviado el {{quando}} por {{nome}}',
    concluido_other: '{{count}} e-mails enviados el {{quando}} por {{nome}}',
    falhas_one: '{{count}} con error',
    falhas_other: '{{count}} con error',
    interrompido: 'El envío se detuvo el {{quando}}: {{enviados}} de {{total}} enviados.',
  },
  detalhe: {
    semTentativas: 'Ninguna intento de envío.',
    resultado: 'Motivo',
    historico: 'Intentos',
  },
  idioma: {
    rotulo: 'Idioma del e-mail',
    cadaUm: 'El idioma de cada persona',
    previa: 'Ver en',
  },
  modelo: {
    titulo: 'Texto del e-mail',
    padrao: 'Texto predeterminado',
    editadoPor: 'Editado por {{nome}} el {{quando}}',
    corpo: 'Cuerpo',
    voltarSalvar: 'Volver y guardar',
    saidaTitulo: 'Hay texto sin guardar',
    salvar: 'Guardar texto',
    descartar: 'Descartar',
    restaurar: 'Restaurar predeterminado',
    restaurarTitulo: '¿Restaurar el texto predeterminado?',
    restaurarCorpo: 'El texto editado de este idioma se borra y vuelve el predeterminado.',
    salvo: 'Texto guardado. Los próximos envíos usan este texto.',
    restaurado: 'Texto predeterminado restaurado.',
    variavelDesconhecida:
      'Variable desconocida en el texto: {{variaveis}}. Use {nome}, {campanha}, {inicio} o {fim}.',
  },
  envio: {
    publico_zero: '{{count}} personas',
    publico_one: '{{count}} persona',
    publico_other: '{{count}} personas',
    resumo: '{{pessoas}}, {{receberao}}',
    receberao_zero: '{{count}} lo recibirán',
    receberao_one: '{{count}} lo recibirá',
    receberao_other: '{{count}} lo recibirán',
  },
  dialogo: {
    titulo: 'Enviar invitaciones',
    enviar: 'Enviar',
  },
} as const satisfies Traducao<typeof pt>;
